import { render, staticRenderFns } from "./PublicationModal.vue?vue&type=template&id=5674d268&"
import script from "./PublicationModal.vue?vue&type=script&lang=js&"
export * from "./PublicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports